const RECRUITMENT = {
  $recruitment: true,
  $education: false,
  participant: 'candidate',
  Participant: 'Candidate',
  participants: 'candidates',
  Participants: 'Candidates',
};
const EDUCATION = {
  $recruitment: false,
  $education: true,
  participant: 'student',
  Participant: 'Student',
  participants: 'students',
  Participants: 'Students',
};
const types = {
  recruitment: RECRUITMENT,
  education: EDUCATION,
};

// Sort of hackish way to configure variances based on a recruiting or education target

export const productTypeServiceModule = angular
  .module('Q.services.product-type-service', [])

  .constant('PT', angular.extend({}, RECRUITMENT))

  .factory('productTypeService', function ($rootScope, PT, $document) {
    /**
     * Replaces occurrences `{{word}}` with either the matching product type string, or leaving `word`
     * untouched if there's no match.
     * @param {String} string String to modify
     */
    function replace(string) {
      return string.replace(/\{\{(\w+)\}\}/g, (_, w) => PT[w] || w);
    }

    /**
     * Returns the correct for for the given count
     * @param {String} single
     * @param {String} plural
     * @param {Number} count
     * @returns {String}
     */
    function pluralize(single, plural, count) {
      return count === 1 ? single : plural;
    }

    return {
      types,
      // Intital setup, sets the product to default recruitment mode, to ensure we have something
      // if the app has not loaded
      init() {
        this.setProduct('recruitment');
      },
      /**
       * Sets the current product type based on the team
       * Can be called after setup, but should be set as early as possible.
       * @param {Team|String} team Team object to use for configuring the app
       */
      setProduct(team) {
        $rootScope.PT = RECRUITMENT;
        let productTypes = team && team.productTypes;
        if (team === 'education') {
          $rootScope.PT = EDUCATION;
        } else if (productTypes && !productTypes.recruitment) {
          if (productTypes.education) {
            $rootScope.PT = EDUCATION;
          }
        }
        const rPT = $rootScope.PT;
        rPT.$replace = replace;
        rPT.$pluralize = pluralize.bind(rPT, rPT.participant, rPT.participants);
        rPT.$Pluralize = pluralize.bind(rPT, rPT.Participant, rPT.Participants);

        angular.extend(PT, rPT);
        $document.toggleClass('product-type-recruitment', PT.$recruitment);
        $document.toggleClass('product-type-education', PT.$education);
      },
      replace,
    };
  })

  .directive('qPt', function (PT) {
    return {
      link(scope, elem) {
        let text = elem.text();
        let key = text.replace(/\W+/, '');
        if (PT[key]) {
          // we do it this way to preserve whitespace & punctuation
          elem.text(text.replace(key, PT[key]));
        }
      },
    };
  })

  .run(function ($rootScope, productTypeService) {
    productTypeService.init();
    $rootScope.$on('app.accountSet', ($event, account) => {
      if (account && account.user && account.user.team) {
        productTypeService.setProduct(account.user.team);
      }
    });
  });
